import Vue from "vue";
import axios from "axios";

export default {
  name: "Users",
  data: function () {
    return {
      user: { login: "", name: "", role: -1, email: "", authenticated: false },
      preference: {
        preferenced: false,
        linkToWarehouse: false,
        warehouseId: -1,
        meterWarehouseId: -1,
      },
      profile: { login: "", name: "", role: "", email: "" },
    };
  },
  computed: {
    roles: function () {
      return { Employee: 1, Customer: 2 };
    },
    userAuthenticated: function () {
      return this.user && this.user.authenticated;
    },
  },
  methods: {
    resetUserDetails() {
      this.user = {
        login: "",
        name: "",
        role: -1,
        email: "",
        authenticated: false,
      };
      this.preference = {
        preferenced: false,
        linkToWarehouse: false,
        warehouseId: -1,
        meterWarehouseId: -1,
      };
    },
    async getUserDetails() {
      if (
        this.$route.name == "resetPassword" ||
        this.$route.name == "confirmLink"
      )
        return;

      var login = this.$localStorage.get("_login");
      if (login == null || login == undefined || login == "null") {
        if (this.$route.name != "login") this.$router.push("/login");
      } else {
        await axios
          .post("/account/GetProfileDetails", { Username: login })
          .then((response) => {
            if (response.data.data.status == 0) {
              this.$store.commit("setUserProfile", response.data.item);
              if (
                response.data.item.isFieldWorker &&
                !response.data.item.portalMaintenanceCrmFull
              )
                this.$store.commit("setIsFieldWorker", true);
              else this.$store.commit("setIsFieldWorker", false);

              var resp = response.data.item;
              this.user = {
                login: login,
                name: resp.name,
                role: resp.role,
                email: resp.email,
                account: resp.account,
                authenticated: true,
                isFieldWorker: resp.isFieldWorker,
              };
              this.profile.login = login;
              this.profile.name = resp.name;
              this.profile.role = resp.role;
              this.profile.email = resp.email;

              this.preference = {
                preferenced: false,
                linkToWarehouse: resp.linkToWarehouse,
                warehouseId: resp.warehouseId,
                meterWarehouseId: resp.meterWarehouseId,
              };

              this.$localStorage.set(
                "_preference",
                JSON.stringify(this.preference)
              );
              this.$localStorage.set("_profile", JSON.stringify(this.profile));
              this.getElementTypesPlain();

              // if (this.dashBoards && this.dashBoards.allow && this.dashBoards.showOnStart && !response.data.item.isFieldWorker)
              //   this.$router.push('/dashboards');
              // else
              if (this.$route.name == "home" || this.$route.name == "login")
                this.$router.push("/employeeHome");
            } else {
              this.resetUserDetails();
              this.$router.push("/login");
            }
          })
          .catch((e) => {
            this.resetUserDetails();
            this.$router.push("/login");
          });
      }
    },
    getLoginName() {
      return this.$localStorage.get("_login");
    },
    getUserName() {
      let prof = this.$localStorage.get("_profile");

      if (!prof) return "";

      return JSON.parse(prof).name;
    },
    readSecurities(pageName, controls) {
      var sUrl = "/account/GetSecuritiesEmployee";

      var _profile = this.$localStorage.get("_profile");

      this.profile = JSON.parse(_profile);
      if (!this.profile)
        this.profile = { login: "", name: "", role: "", email: "" };

      if (this.profile.role == this.roles.Customer) {
        sUrl = "/account/GetSecuritiesCustomer";
      }
      axios
        .post(sUrl, { Value: pageName })
        .then((response) => {
          if (
            response.data.data.status == 0 &&
            response.data.items.length > 0
          ) {
            response.data.items.forEach((item) => {
              var control = controls[item.name];
              if (control) {
                if (control.employee)
                  if (
                    control.employee.visible != undefined &&
                    item.employee.visible != undefined
                  )
                    control.employee.visible = item.employee.visible;
                if (control.employee)
                  if (
                    control.employee.disabled != undefined &&
                    item.employee.disabled != undefined
                  )
                    control.employee.disabled = item.employee.disabled;
                if (control.customer)
                  if (
                    control.customer.visible != undefined &&
                    item.customer.visible != undefined
                  )
                    control.customer.visible = item.customer.visible;
                if (control.customer)
                  if (
                    control.customer.disabled != undefined &&
                    item.customer.disabled != undefined
                  )
                    control.customer.disabled = item.customer.disabled;
              }
            });
          }
        })
        .catch((e) => {
          // no securities to apply
        });
    },
    showSecurities(controls) {
      for (var key in controls) {
        if (controls.hasOwnProperty(key)) {
          var control = this.edams_controls[key];
          if (control) {
            if (control.employee)
              if (control.employee.visible != undefined)
                control.employee.visible = true;
            if (control.employee)
              if (control.employee.disabled != undefined)
                control.employee.disabled = false;
            if (control.customer)
              if (control.customer.visible != undefined)
                control.customer.visible = true;
            if (control.customer)
              if (control.customer.disabled != undefined)
                control.customer.disabled = false;
          }
        }
      }
    },
    getElementTypesPlain() {
      axios
        .get("/Element/GetElementTypesPlain")
        .then((response) => {
          if (response.status == 200) {
            this.$store.commit("setElementTypesPlain", response.data.items);
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((errpr) => {
          this.$alertMsg(errpr.response.data);
        });
    },

    async lockApplication(applicationId) {
      if (!applicationId || applicationId < 0) return false;

      let param = { ApplicationId: applicationId };

      return await axios
        .post("/EmployeeApplication/LockApplication", param)
        .then((resp) => {
          this.savingTask = false;
          if (resp.status == 200)
            return {
              success: !resp.data.isLockedToAnotherEmployee,
              resp: resp.data,
            };
          else return { success: false };
        })
        .catch((err) => {
          //this.$alertMsg(err.response.data);
          this.savingTask = false;
          return { success: false, resp: err.response.data };
        });
    },
    async unlockApplication(applicationId) {
      if (!applicationId || applicationId < 0) return false;

      let param = { ApplicationId: applicationId };

      return await axios
        .post("/EmployeeApplication/UnlockApplication", param)
        .then((resp) => {
          if (resp.status == 200) {
            this.savingTask = false;
            return true;
          }
          this.savingTask = false;
          return false;
        })
        .catch((err) => {
          //this.$alertMsg(err);
          this.savingTask = false;
          return false;
        });
    },
  },
};
